import template from './client-filter.html';
import controller from './client-filter.controller';

let clientFilterComponent = {
    bindings: {
        onUpdate: '&'
    },
    template,
    controller
};

export default clientFilterComponent;
